import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, CardBody, Card, Table, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux
import { values } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { DatePickerInput, DatesProvider, DateTimePicker } from '@mantine/dates';
import { setRequireCloseModal } from '../../../slices/personalProtectiveEquipment/reducer';
import { getPersonList, } from '../../../helpers/establishment/backend_helper';
import { deliverWarehouseItem, getEstablishmentTypeList, getPersonalProtectiveEquipmentList, getPersonalProtectiveEquipmentStatusByCode, getWarehouseGroupExist, receiveWarehouseItem, updatePersonalProtectiveEquipment, uploadFoldersFile, } from '../../../slices/thunks';
import OSelect from '../../../Components/OElements/OSelect';
import SimpleBar from 'simplebar-react';
import useLogoLoader from '../../../Components/Hooks/useLogoLoaderHooks';
import useFileType from '../../../Components/Hooks/useFileTypeHooks';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { getWarehouseGroup } from '../../../helpers/warehouse/backend_helper';
import OInput from '../../../Components/OElements/OInput';

const PersonalProtectiveEquipmentReceive = ({ dataPersonalProtectiveEquipment, handleToggleModalReceive, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();
	const { logoSrc } = useLogoLoader('login');

	const [folderPaths, setFolderPaths] = useState([]);
	const [selectedEstablishment, setSelectedEstablishment] = useState(null);
	const [selectedPerson, setSelectedPerson] = useState(null);
	const [loading, setLoading] = useState(false);
	const [typeDocument, setTypeDocument] = useState(null);

	const [fileName, setFileName] = useState('');
	const { file_type } = useFileType('EPPR');

	const selectorEstablishmentTypes = createSelector(
		state => state.EstablishmentTypes,
		data => ({
			itemEstablishmentTypeList: data.itemEstablishmentTypeList,
		})
	);

	const { itemEstablishmentTypeList, } = useSelector(selectorEstablishmentTypes);

	const selectorPersonalProtectiveEquipment = createSelector(
		state => state.PersonalProtectiveEquipments,
		data => ({
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
			itemPersonalProtectiveEquipmentDetail: data.itemPersonalProtectiveEquipmentDetail,
		})
	);

	const { isLoadingList, requireCloseModal, itemPersonalProtectiveEquipmentDetail } = useSelector(selectorPersonalProtectiveEquipment);

	const selectorWarehouse = createSelector(
		state => state.Warehouses,
		data => ({
			itemWarehouseDetail: data.itemWarehouseDetail,
		})
	);

	const { itemWarehouseDetail } = useSelector(selectorWarehouse);


	useEffect(() => {
		dispatch(getEstablishmentTypeList());
		dispatch(getPersonalProtectiveEquipmentStatusByCode('RPD'));
	}, []);

	const uploadDocument = async (file, folderPaths, fileTypeId, establishmentId) => {
		if (!(file instanceof File)) {
			throw new Error("El archivo seleccionado no es válido.");
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("file_type_id", fileTypeId);
		formData.append("establishment_id", establishmentId);

		folderPaths.forEach(path => formData.append("folder_paths", path));

		// console.log("FormData antes de la subida:");
		// for (let pair of formData.entries()) {
		// 	console.log(pair[0], pair[1]);
		// }

		try {
			const response = await dispatch(uploadFoldersFile(formData)).unwrap();
			return response;
		} catch (error) {
			console.error("Error uploading file:", error);
			throw error;
		}
	};




	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			receive_person_id: '',
			receive_date: '',
			document: '',
			file: '',
		},
		validationSchema: Yup.object({
			receive_person_id: Yup.string().required('Campo requerido'),
			receive_date: Yup.string().required('Campo requerido'),
			document: Yup.string().required('Campo requerido'),
			file: Yup.string().nullable(),
		}),
		onSubmit: async (values) => {
			setLoading(true);

			try {
				const folder = buildFolderPath(dataPersonalProtectiveEquipment, itemEstablishmentTypeList);
				const updatedFolderPaths = [...folderPaths, folder];

				const documents = await uploadDocument(
					values.document,
					updatedFolderPaths,
					file_type._id,
					dataPersonalProtectiveEquipment.establishment_id
				);
				const document = documents[documents.length - 1];

				const docEntries = [];

				// DESHABILITAR DESCUENTO EN SAP CUANDO ES DEVOLUCIÓN
				// const transferList = await buildTransferList(dataPersonalProtectiveEquipment);
				// if (!transferList) return;
				// for (const transferItem of transferList) {
				// 	const docEntry = await dispatch(receiveWarehouseItem(transferItem)).unwrap();
				// 	docEntries.push({ warehouse_item_id: transferItem.warehouse_item_id, doc_entry: entry['doc_entry'], doc_num: entry['doc_num'] });
				// }

				// Crea nuevo array sin mutar
				const updatedAssignedItems = dataPersonalProtectiveEquipment.assigned_items.map(item => {
					const match = docEntries.find(d => d.warehouse_item_id === item.warehouse_item_id);
					return match ? { ...item, doc_entry: match.doc_entry } : item;
				});

				// AHORA se construye formData correctamente
				const formData = buildFormData(values, document._id, dataPersonalProtectiveEquipment, updatedAssignedItems);

				await dispatch(updatePersonalProtectiveEquipment(formData));
				dispatch(getPersonalProtectiveEquipmentList());
				dispatch(setRequireCloseModal(true));
				handleToggleModalReceive();
			} catch (error) {
				console.error(error);
				toast.error('Ocurrió un error al procesar la devolución.');
			} finally {
				setLoading(false);
			}

		}
	});

	// Función auxiliar para construir el folder path
	function buildFolderPath(data, typeList) {
		const type = typeList.find(t => t._id === data.establishment.establishment_type_id);
		const typeName = type?.name || '';
		const codePart = data.establishment.code_siep ? `${data.establishment.code_siep} - ` : '';
		return `/${typeName}/${codePart}${data.establishment.name}/Abastecimiento/EPP/Devolución`;
	}

	// Función auxiliar para preparar la lista de transferencias
	async function buildTransferList(data) {
		const list = [];
		let hasError = false;

		for (const item of data.assigned_items) {
			try {
				const response = await dispatch(getWarehouseGroupExist({
					establishment_id: data.establishment_id,
					group_code: item.warehouse_group_code
				}));

				list.push({
					source_warehouse_code: response.payload.group.warehouse_code,
					destination_warehouse_code: item.warehouse_code,
					warehouse_item_id: item.warehouse_item_id,
					quantity: item.quantity
				});
			} catch (error) {
				hasError = true;
				console.error("Error al obtener grupo de almacén:", item, error);
			}
		}

		if (hasError) {
			toast.error('Hubo errores con algunos ítems. Verifique configuración de almacenes.');
			setLoading(false);
			return null;
		}

		return list;
	}

	// Función auxiliar para construir el formData final
	function buildFormData(values, documentId, data, assignedItems) {
		return {
			_id: data._id,
			assigned_items: assignedItems,
			person_id: data.person_id,
			establishment_id: data.establishment_id,
			warehouse_id: data.warehouse_id,
			receive_person_id: values.receive_person_id,
			receive_date: values.receive_date,
			receive_document_id: documentId,
			pick_person_id: data.pick_person_id,
			pick_date: data.pick_date,
			document_id: documentId,
			assignment_date: data.assignment_date,
			personal_protective_equipment_status_id: itemPersonalProtectiveEquipmentDetail._id,
			personal_protective_equipment_reason_id: data.personal_protective_equipment_reason_id,
			assignment_document_id: data.assignment_document_id,

			cost_center: selectedPerson.cost_center?.code || null,
			management_id: selectedPerson.management?._id || null,
		};
	}


	const columns = useMemo(
		() => [
			{ header: 'Elemento', accessorKey: 'name', size: 'auto' },
			{ header: 'Talla', accessorKey: 'size', size: 'auto' },
			{ header: 'Cantidad', accessorKey: 'quantity', size: 'auto' },
			{ header: 'Unidad', accessorKey: 'unit_measurement_name', size: 'auto' },
		],
	);

	const handleFileChange = (event) => {
		const file = event.target.files[0] || null;
		if (file) {
			validation.setFieldValue("document", file);
			validation.setFieldValue("file", file);
			setFileName(file.name); // Solo actualizamos el nombre del archivo para mostrarlo en UI
		} else {
			validation.setFieldValue("document", '');
			validation.setFieldValue("file", '');
			setFileName('');
		}
	};


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<OSelect
									key={`receive_person_id${values.receive_person_id}` || ''}
									label='Persona que Recepciona'
									id='receive_person_id'
									name='receive_person_id'
									isRequired={true}
									value={validation.values.receive_person_id || ''}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									onSelect={setSelectedPerson}
									requestApi={() => getPersonList({})}
									validation={validation}
								/>
							</Col>
							<Col sm={3}>
								<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
									<DatePickerInput
										label={
											<span>
												Fecha de Recepción <span style={{ color: 'red' }}>*</span>
											</span>
										}
										id='receive_date'
										name='receive_date'
										placeholder="Seleccione una fecha"
										value={
											validation.values.receive_date
												? new Date(validation.values.receive_date)
												: null
										}
										onChange={(date) => { validation.setFieldValue("receive_date", date); }}
										onBlur={validation.handleBlur}
										valueFormat='DD-MM-YYYY'
										maxDate={new Date()}
										// minDate={new Date(new Date().setDate(new Date().getDate() - 10))} // Set minDate to 5 days before today
										error={
											validation.touched['receive_date'] && validation.errors['receive_date']
												? validation.errors['receive_date']
												: ''
										}
										clearable={true}
									/>
								</DatesProvider>
							</Col>

							<Col lg={6}>
								<Label for="document">Documento Firmado <span style={{ color: 'red' }}>*</span></Label>
								<Input
									name='document'
									id='document'
									className='form-control'
									placeholder='Ingrese el documento'
									type='file'
									validate={{ required: { value: true } }}
									value={fileName ? undefined : ''} // Resetea el valor si no hay archivo
									onChange={handleFileChange}
									onBlur={validation.handleBlur}
									invalid={validation.touched.document && validation.errors.document ? true : false}
								/>
								{validation.touched.document &&
									validation.errors.document ? (
									<FormFeedback type='invalid'>
										{validation.errors.document}
									</FormFeedback>
								) : null}
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row>
							<Col lg={12}>
								<SimpleBar style={{ maxHeight: "300px" }}>
									<ODataGrid
										enableTopToolbar={false}
										columns={columns}
										data={dataPersonalProtectiveEquipment.assigned_items}
										nameFile={'items_para_entrega'}
									/>
								</SimpleBar>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody >
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModalReceive();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={loading}
					>
						{loading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						Recepcionar Elementos de Protección Personal
					</button>
				</div>
			</div>
		</Form >
	);
};

export default PersonalProtectiveEquipmentReceive;
